import { SELF_SERVE_CAMPAIGN_PROMOTIONS } from '../constants/campaignPromotions';

export function getSelfServeCampaignPromotion(campaignId) {
  const trimmed = campaignId?.trim();
  if (!trimmed) {
    return null;
  }
  return Object.hasOwn(SELF_SERVE_CAMPAIGN_PROMOTIONS, trimmed)
    ? SELF_SERVE_CAMPAIGN_PROMOTIONS[trimmed]
    : null;
}

/**
 * Discount preview for the selected plan, or null when the campaign or plan has no mapping.
 * @returns {{ promotionCode: string, percentOff: number } | null}
 */
export function getCampaignCheckoutDiscount(campaignId, planCode) {
  const campaign = getSelfServeCampaignPromotion(campaignId);
  const promotionCode = planCode && campaign?.promotionCodes[planCode];
  if (!promotionCode) {
    return null;
  }
  return { promotionCode, percentOff: campaign.percentOff };
}
